
import React from "react";
import { Button, Form } from "react-bootstrap";
import "./register.css"

function Register({ handleClose, show }){

    const showHideClassName = show ? "modal display-block" : "modal display-none";

    return (

        <div id="register-body" className={showHideClassName}>
            <div id="register-content">
                <Form id="register-input-form">
                    <h3>Register</h3>
                    <Form.Group>
                        <h2>First name</h2>
                        <Form.Control id="firstname" type="Text" placeholder="First Name"></Form.Control>
                    </Form.Group>

                    <Form.Group>
                        <h2>Last name</h2>
                        <Form.Control id="lastname" type="Text" placeholder="Last Name"></Form.Control>
                    </Form.Group>

                    <Form.Group>
                        <h2>Email</h2>
                        <Form.Control id="email" type="Text" placeholder="Email@mail.com"></Form.Control>
                    </Form.Group>

                    <Form.Group>
                        <label>Password</label>
                        <Form.Control id="password" type="password" placeholder="*******************"></Form.Control>
                    </Form.Group>

                    <Button type="submit" className="register-button">Register</Button>
                </Form>
                <Button type="button" onClick={handleClose}>
                Close
                </Button>
            </div>
        </div>
        
    );

}

export default Register;








